<template>
    <BaseForm v-if="project && errors">
        <template #fields>
            <TextAreaField
                :value="values.notesDayOrder"
                :label="$t('project-notes-dayorder')"
                :error-messages="errors.notesDayOrder"
                :max-length="ProjectSeriesAppointmentSchema.shape.notesDayOrder.maxLength ?? undefined"
                @input="setFieldValue('notesDayOrder', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('notesDayOrder', true)"
            />
            <TextAreaField
                :value="values.notesAppointment"
                :label="$t('project-notes-appointment')"
                :error-messages="errors.notesAppointment"
                :max-length="ProjectSeriesAppointmentSchema.shape.notesAppointment.maxLength ?? undefined"
                @input="setFieldValue('notesAppointment', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('notesAppointment', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectInjection } from '@/project/composables/useProjectInjection';
import { ProjectAppointmentSchema, ProjectSeriesAppointmentSchema } from '@/project/schemas';
import { computed } from 'vue';

const props = defineProps<{ projectId: string }>();

const projectId = computed(() => props.projectId);

const { project, updateProject } = useProjectInjection();

const { values, errors, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    ProjectAppointmentSchema,
    computed(() => ({
        notesDayOrder: project.value?.notesDayOrder ?? '',
        notesAppointment: project.value?.notesAppointment ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateProject({ id: projectId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
